import { PenTool } from 'lucide-react'

import { PenNodeEdit } from './pen-node-edit-icon'
import { PenPlusMinus } from './pen-plus-minus-icon'

interface PenToolButtonIconProps {
  isPenEditMode: boolean
  isNodeEditMode: boolean
}

/** Pen Tool button glyph: pen± while in node-edit pen sub-mode, the node-edit cursor while in
 *  node-edit mode otherwise, and the plain pen everywhere else. */
export function PenToolButtonIcon({ isPenEditMode, isNodeEditMode }: PenToolButtonIconProps) {
  if (isPenEditMode) return <PenPlusMinus className="w-4 h-4" />
  if (isNodeEditMode) return <PenNodeEdit className="w-4 h-4" />

  return <PenTool className="w-4 h-4" />
}
